import { InputHTMLAttributes } from 'react';

import { Control, Controller } from 'react-hook-form';

import CurrencyInput from 'react-currency-input';

import '../input/style.css';
import {
	ContainerStyled,
	GroupStyled,
	ErrorStyled,
	ErrorDivStyled,
} from '../input/style';

export interface InputProps extends InputHTMLAttributes<any> {
	// React-hook-form
	name: string;
	control?: Control;
	error?: string;
	value?: any;
	useExternalValue?: boolean;
	dataTestId?: string;

	// CurrencyInput
	decimalSeparator?: string;
	precision?: string;
	thousandSeparator?: string;
	dataTestID?: string;
	prefix?: string;
}

export function InputControlledCurrency({
	name,
	control,
	error,
	value,
	dataTestID,
	useExternalValue,
	decimalSeparator = ',',
	precision,
	thousandSeparator = '.',
	prefix = 'R$',
	...rest
}: InputProps) {
	return (
		<GroupStyled>
			<ContainerStyled>
				<Controller
					control={control}
					name={name}
					render={({ field: { onChange, value: valueForm } }) => (
						<CurrencyInput
							prefix={prefix}
							style={{ width: rest.width }}
							placeholder={rest.placeholder}
							value={useExternalValue ? value : valueForm}
							decimalSeparator={decimalSeparator}
							thousandSeparator={thousandSeparator}
							precision={precision}
							onChange={onChange}
							data-testid={dataTestID}
							disabled={rest.disabled}
						/>
					)}
				/>
			</ContainerStyled>
			<ErrorDivStyled>
				{error && <ErrorStyled>{error}</ErrorStyled>}
			</ErrorDivStyled>
		</GroupStyled>
	);
}
